import store from '../store'
import router from '../router'
import axios from 'axios'
import VueAxios from 'vue-axios'

import {API_SERVER, AUTHORIZATION, ACCESS_TOKEN, token, BASE_URL} from '../constants/constants'

axios.defaults.baseURL = API_SERVER + BASE_URL
axios.interceptors.request.use(function (config) {
  config.headers.common[ACCESS_TOKEN] = token
  if (store.getters.currentToken) {
    config.headers.common[AUTHORIZATION] = store.getters.currentToken
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
axios.interceptors.response.use(function (response) {
  if (response.data && response.data.status === 401) {
    store.dispatch('resetAuth')
    router.push('/login')
  }
  return response
}, function (error) {
  if (error.response && error.response.status === 401) {
    store.dispatch('resetAuth')
    router.push('/login')
  }
  return Promise.reject(error)
})

export default {
  install (Vue) {
    Vue.use(VueAxios, axios)
  }
}
